// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"185":"fd0f2399","426":"bb297d94","466":"b242bf37","677":"5dda2a4e"}[chunkId] + ".chunk.js";
};